<template>
  <div>
    <div v-for="shipmentOrder in invoiceValues">
      <div v-if="shipmentOrder" class="box sc-pre-invoice-detail-value__box">
        <div class="columns is-multiline">
          <!-- Nota Fiscal -->
          <div class="column is-6 is-3-widescreen">
            <article class="panel is-primary">
              <p class="panel-heading has-text-primary has-text-weight-bold">
                {{ getInvoiceLabel(shipmentOrder.invoice) }}
              </p>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold"> {{ getInvoiceLabel(shipmentOrder.invoice) }}: </h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder && shipmentOrder.invoice">
                      {{ getInvoiceIdentifier(shipmentOrder.invoice) }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Valor {{ getInvoiceLabel(shipmentOrder.invoice) }}: </h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder && shipmentOrder.invoice && shipmentOrder.invoice.value">
                      {{ shipmentOrder.invoice.value | currency }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Valor dos produtos:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p>{{ shipmentOrder.products_value | currency }}</p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Valor Frete:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p>{{ shipmentOrder.total_value | currency }}</p>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <!-- Documento de Transporte -->
          <div class="column is-6 is-3-widescreen">
            <article class="panel sc-pre-invoice-detail-value__panel is-primary">
              <p class="panel-heading has-text-primary has-text-weight-bold">
                Documento de Transporte
              </p>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Número do Documento:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder.cte && shipmentOrder.cte.number && shipmentOrder.cte.serie">
                      {{ `${shipmentOrder.cte.number}-${shipmentOrder.cte.serie}` }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Emissor:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder.cte && shipmentOrder.cte.company_name">
                      {{ shipmentOrder.cte.company_name }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Valor Frete:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder.cte && shipmentOrder.cte.freight_value">
                      {{ shipmentOrder.cte.freight_value | currency }}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <!-- Dados Complementares -->
          <div class="column is-6 is-3-widescreen">
            <article class="panel sc-pre-invoice-detail-value__panel is-primary">
              <p class="panel-heading has-text-primary has-text-weight-bold">
                Dados Complementares
              </p>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">Número do Pedido:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p>
                      <a :href="`/ng#/order-number/${shipmentOrder.order_number}`">
                        {{ shipmentOrder.order_number }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">CEP Origem:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder && shipmentOrder.origin_zipcode">
                      {{ parseCEP(shipmentOrder.origin_zipcode) | cep }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="panel-block page-pre-invoice-detail__panel__block">
                <div class="columns page-pre-invoice-detail__cols">
                  <div class="column is-narrow">
                    <h6 class="has-text-weight-bold">CEP Destino:</h6>
                  </div>
                  <div class="column has-text-right">
                    <p v-if="shipmentOrder && shipmentOrder.destination_zipcode">
                      {{ parseCEP(shipmentOrder.destination_zipcode) | cep }}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <!-- Volumes -->
          <div class="column is-6 is-3-widescreen">
            <article class="panel sc-pre-invoice-detail-value__panel sc-pre-invoice-detail-value__panel--volumes is-primary">
              <div class="panel-heading has-text-primary has-text-weight-bold">
                <p>Volumes</p>
                <small>
                  <button
                    @click="showAllVolumes(shipmentOrder.volumes)"
                    :disabled="!shipmentOrder.volumes || shipmentOrder.volumes.length === 0"
                    class="button is-text has-text-primary">
                    Ver todos
                  </button>
                </small>
              </div>

              <template>
                <sc-tabs
                  v-if="shipmentOrder.volumes && shipmentOrder.volumes.length > 0"
                  v-model="activeTab"
                  :animated="false"
                  class="sc-pre-invoice-detail-value__panel__tabs">
                  <sc-tab-item
                    v-for="(volume, index) in shipmentOrder.volumes"
                    :label="`Volume ${index + 1}`"
                    :key="index"
                    class="page-pre-invoice-detail__panel__block vertical">
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Código de rastreio:</h6>
                      </div>

                      <div class="column has-text-right">
                        <a
                        :href="`http://status-testing.intelipost.com.br/tracking/${volume.tracking_code}`"
                        target="_blank">
                        {{ volume.tracking_code }}
                      </a>
                      </div>
                    </div>
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p>{{ volume.weight }}</p>
                      </div>
                    </div>
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso Cubado:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p>{{ volume.squared_weight }}</p>
                      </div>
                    </div>
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso Selecionado:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p>{{ volume.selected_weight }}</p>
                      </div>
                    </div>
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Dimensões:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p>{{ transformDimensions(volume.dimensions) }}</p>
                      </div>
                    </div>
                  </sc-tab-item>
                </sc-tabs>

                <template v-else class="panel sc-pre-invoice-detail-value__panel is-primary">
                  <div class="panel-block page-pre-invoice-detail__panel__block">
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p></p>
                      </div>
                    </div>
                  </div>

                  <div class="panel-block page-pre-invoice-detail__panel__block">
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso Cubado:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p></p>
                      </div>
                    </div>
                  </div>

                  <div class="panel-block page-pre-invoice-detail__panel__block">
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Peso Selecionado:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p></p>
                      </div>
                    </div>
                  </div>

                  <div class="panel-block page-pre-invoice-detail__panel__block">
                    <div class="columns page-pre-invoice-detail__cols">
                      <div class="column is-narrow">
                        <h6 class="has-text-weight-bold">Dimensões:</h6>
                      </div>

                      <div class="column has-text-right">
                        <p></p>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </article>
          </div>
        </div>
      </div>

      <div class="box" style="margin-bottom: 2rem;">
        <sc-table
          :data="shipmentOrder.taxes"
          :paginated="isPaginated(shipmentOrder.taxes)"
          :per-page="pagination.limit"
          class="sc-pre-invoice-detail-value__table"
          :row-class="(row) => getClassByMarginStatus(row)">
          <template slot-scope="{ row }">
            <sc-table-column
              label="Taxa"
              field="name"
              sortable>
              {{ row.name }}
            </sc-table-column>

            <sc-table-column
              label="Tipo"
              field="type"
              sortable>
              {{ getTaxTypeEnum(row.type) }}
            </sc-table-column>

            <sc-table-column
              label="Valor TMS"
              field="values.tms.value"
              sortable>
              <sc-tooltip
                v-if="!cteNotInformed(row) && isDifferent(row)"
                label="Valores do TMS e do CTE não são iguais"
                type="is-dark"
                dashed>
                <p :class="getClassByDifference(row)">
                  {{ row.values.tms.value | currency }}
                </p>
              </sc-tooltip>

              <template v-else>
                {{ row.values.tms.value | currency }}
              </template>
            </sc-table-column>

            <sc-table-column
              label="TMS %"
              field="values.tms.percent"
              sortable>
              <sc-tooltip
                v-if="isDifferent(row, 'percent')"
                label="Porcentagens do TMS e do CTE não são iguais"
                type="is-dark"
                dashed>
                <p :class="getClassByDifference(row, 'percent')">
                  {{ row.values.tms.percent }}
                </p>
              </sc-tooltip>
              <template v-else>
                {{ row.values.tms.percent }}
              </template>
            </sc-table-column>

            <sc-table-column
              label="Valor CTE"
              field="values.cte.value"
              sortable>
              <template v-if="cteNotInformed(row)">
                <sc-icon icon="exclamation-triangle" size="is-small" type="is-warning" /> Valor não informado
              </template>

              <sc-tooltip
                v-else-if="!cteNotInformed(row) && isDifferent(row)"
                label="Valores do TMS e do CTE não são iguais"
                type="is-dark"
                dashed>
                <p :class="getClassByDifference(row)">
                  {{ row.values.cte.value | currency }}
                </p>
              </sc-tooltip>
              <template v-else>
                {{ row.values.cte.value | currency }}
              </template>
            </sc-table-column>

            <sc-table-column
              label="CTE %"
              field="values.cte.percent"
              sortable>
              <sc-tooltip
                v-if="isDifferent(row, 'percent')"
                label="Porcentagens do TMS e do CTE não são iguais"
                type="is-dark"
                position="is-left"
                dashed>
                <p :class="getClassByDifference(row, 'percent')">
                  {{ row.values.cte.percent }}
                </p>
              </sc-tooltip>
              <template v-else>
                {{ row.values.cte.percent }}
              </template>
            </sc-table-column>
          </template>

          <template slot="empty">
            <sc-table-empty message="Nenhuma informação de taxas encontrada" />
          </template>
        </sc-table>
      </div>

    </div>
    <sc-modal :active.sync="showVolumesModal">
      <sc-modal-card class="sc-pre-invoice-detail-value__modal">
        <template slot="title">
          <h2 class="modal-card-title">
            Volumes
          </h2>
        </template>

        <template slot="body">
          <sc-pre-invoice-detail-volumes-table :data="currentVolumesModal" />
        </template>
      </sc-modal-card>
    </sc-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScModal,
  ScModalCard,
  ScTabs,
  ScTabItem,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';
import ScPreInvoiceDetailVolumesTable from './components/ScPreInvoiceDetailVolumesTable';

import { getInvoiceIdentifier, getInvoiceLabel } from '../../helpers/invoiceValuesHelper';

const {
  mapActions,
  mapState,
} = createNamespacedHelpers('recon/preInvoiceDetail/preInvoiceDetailValues');

export default {
  name: 'sc-pre-invoice-detail-values',
  data() {
    return {
      showVolumesModal: false,
      activeTab: 0,
      pagination: {
        page: 1,
        limit: 10,
      },
      taxTypesEnum: {
        FEE: 'Taxa',
        TAX: 'Imposto',
      },
      currentVolumesModal: [],
    };
  },
  computed: {
    ...mapState(['invoiceValues']),
  },
  methods: {
    ...mapActions([
      'getInvoiceDetail',
    ]),
    isPaginated(taxes) {
      if (!this.isValidArray(taxes)) {
        return false;
      }

      return taxes.length > this.pagination.limit;
    },
    showAllVolumes(volumes) {
      this.showVolumesModal = true;
      this.currentVolumesModal = volumes;
    },
    transformDimensions(dimensions) {
      const { width, height, length } = dimensions || {};

      const dimensionsList = [width, height, length]
        .filter(item => !!item && typeof item === 'number')
        .map(item => `${item}cm`);

      return dimensionsList.join(' x ');
    },
    isValidArray(list) {
      return list && Array.isArray(list) && list.length > 0;
    },
    getFeeName(name) {
      const fees = {
        other_fee: 'Outras Taxas',
        return_fee: 'Retorno',
        reshipping: 'Reentrega',
        schedule_delivery: 'Agendamento',
        insurance: 'Seguro',
        seccat: 'SEC/CAT',
        cte: 'Taxa por CT-e Emitido',
        delivery: 'Taxa de Entrega',
        pickup: 'Taxa de Coleta',
        toll: 'Pedágio',
        fluvial_insurance: 'Seguro Fluvial',
        exceeding_weight_cost: 'Custo Adicional por kg',
        invoice_percentage_cost: 'Frete Valor',
      };

      return fees[name] ? fees[name] : name;
    },
    getTaxTypeEnum(type) {
      return this.taxTypesEnum[type] ? this.taxTypesEnum[type] : null;
    },
    parseCEP(originalCEP) {
      return (originalCEP && originalCEP.length <= 7) ? `0${originalCEP}` : originalCEP;
    },
    getClassByMarginStatus(row, type = 'row') {
      const { margin_status } = row || {};
      const { value } = margin_status || {};

      const possibleStatus = {
        OUT_OF_MARGIN: 'danger',
      };

      return possibleStatus[value] ? `sc-pre-invoice-detail-value__table__${type}--${possibleStatus[value]}` : false;
    },
    isDifferent(row, type = 'value') {
      const { values } = row || {};
      const { cte, tms } = values || {};

      return cte[type] !== tms[type];
    },
    cteNotInformed(row) {
      const { values } = row || {};
      const { tms, cte } = values || {};
      const { value: tmsValue } = tms || {};
      const { value: cteValue } = cte || {};

      return !cteValue && tmsValue;
    },
    getClassByDifference(row, type = 'value') {
      return this.isDifferent(row, type) && 'sc-pre-invoice-detail-value__table__text--danger';
    },
    getInvoiceIdentifier,
    getInvoiceLabel,
  },
  beforeMount() {
    const { id } = this.$route.params || {};
    const { action } = this.$route.query || {};

    this.getInvoiceDetail({ id, action });
  },
  components: {
    ScButton,
    ScModal,
    ScModalCard,
    ScTabs,
    ScTabItem,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTooltip,
    ScIcon,
    ScPreInvoiceDetailVolumesTable,
  },
};
</script>

<style lang="scss" scoped>
$row-danger: #feecf0;
$row-warning: #fffbeb;
$row-success: #effaf3;

.box {
  margin: 0;
}

.sc-pre-invoice-detail-value {
  &__box {
    justify-content: stretch;
  }

  &__content {
    + .sc-pre-invoice-detail-value__content {
      margin-top: 15px;
    }
  }

  &__panel {
    &__tabs {
      border: 1px solid #e7e7e7;
      border-top-width: 0px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      .tabs ul {
        justify-content: center;
      }

      .tab-content {
        padding: .75rem !important;

        .column {
          padding: 0.5rem;
        }

        .page-pre-invoice-detail__cols + .page-pre-invoice-detail__cols {
          border-top: 1px solid #e7e7e7;
        }
      }
    }

    &.sc-pre-invoice-detail-value__panel--volumes {
      .panel-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.2em 0.75em;

        .button {
          font-weight: normal;
          text-decoration: underline;

          &:hover {
            text-decoration: none;
          }
        }
      }

      .tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  &__table {
    &__row {
      &--danger {
        td {
          background-color: $row-danger;
        }

        &:hover {
          td {
            background-color: darken($row-danger, 1);
          }
        }
      }

      &--warning {
        td {
          background-color: $row-warning;
        }

        &:hover {
          td {
            background-color: darken($row-warning, 2);
          }
        }
      }

      &--success {
        td {
          background-color: $row-success;
        }

        &:hover {
          td {
            background-color: darken($row-success, 2);
          }
        }
      }
    }

    &__text {
      &--danger {
        font-weight: bold;
        color: #e84c3d;
      }

      &--warning {
        font-weight: bold;
        color: #bca316;
      }
    }
  }

  &__modal {
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/ScPreInvoiceDetailValues.vue